import { PortalUserService } from '@aifs-shared/portal/portal-user-service';
import { RoleName } from '@aifs-shared/user/user';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { AgencyInterviewerDetailsResponse, AgentInterviewerDetails, InterviewerService } from './interviewer/interviewer.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IncompleteInterviewReportsComponent } from './interviewer/incomplete-interview-reports.component';
import { InterviewReportsReadyToSubmitComponent } from './interviewer/interview-reports-ready-to-submit.component';
import { UpcomingInterviewsComponent } from './interviewer/upcoming-interviews.component';
import { InterviewReadyInterviewsComponent } from './interviewer/interview-ready-interviews.component';
import { BookmarkDisplayComponent } from './bookmark/bookmark-display.component';
import { CfStatPanelComponent, CFStatPanelStyle } from '@ui/cf-stat-panel/cf-stat-panel.component';
import { RecentlyViewedApplicantsComponent } from './applicant/recently-viewed/recent-applicants.component';
import { ReceivedMessagesComponent } from '@aifs-shared/message/preview/received-message-preview.component';
import { NewsFeedComponent } from './news/feed/news-feed.component';
import { CFBannerType } from '@ui/cf-banner/cf-banner.component';
import { CFButtonStyle, CFButtonType } from '@ui/cf-button/cf-button.component';
import { CFLoaderColor, CFLoaderSize, CFLoaderStyle } from '@ui/cf-loader/cf-loader.component';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-dashboard-main',
    templateUrl: './dashboard-main.component.html',
    styleUrls: ['./dashboard-main.component.scss', 'ui/cf-stat-panel/cf-stat-panel.component.scss',],
    imports: [
        CommonModule,
        FormsModule,
        IncompleteInterviewReportsComponent,
        InterviewReportsReadyToSubmitComponent,
        UpcomingInterviewsComponent,
        InterviewReadyInterviewsComponent,
        BookmarkDisplayComponent,
        CfStatPanelComponent,
        RecentlyViewedApplicantsComponent,
        ReceivedMessagesComponent,
        NewsFeedComponent,
    ]
})

export class DashboardMainComponent implements OnInit {
    loginDisplay = false;
    timeOfDay = 'morning';
    userFirstName = '';

    BannerType = CFBannerType;

    ButtonStyle = CFButtonStyle;
    ButtonType = CFButtonType;

    LoaderSize = CFLoaderSize;
    LoaderStyle = CFLoaderStyle;
    LoaderColor = CFLoaderColor;

    StatPanelStyle = CFStatPanelStyle;

    loggedIn = false;
    userRole = '';
    isAgent = false;
    isInterviewer = false;
    isStaffOnly = false;

    constructor(
        private title: Title,
        private msalAuthService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private portalUserService: PortalUserService,
        private interviewerService: InterviewerService
    ) { }

    ngOnInit(): void {
        this.title.setTitle('Camp America Management Portal');

        this.msalBroadcastService.msalSubject$
            .subscribe((result: EventMessage) => {
                if (result.eventType == EventType.ACQUIRE_TOKEN_SUCCESS) {
                    this.loggedIn = this.msalAuthService.instance.getActiveAccount() != null;
                }
                this.getPermissions();
                this.getInterviewerDetails();
            });

        this.loggedIn = this.msalAuthService.instance.getActiveAccount() != null;
        if (this.loggedIn) {
            // IAS what's the approximate local time of day?
            var hour = DateTime.local().hour;
            switch (true) {
                case hour >= 12 && hour <= 17:
                    this.timeOfDay = "afternoon";
                    break;
                case hour > 17 && hour <= 23:
                    this.timeOfDay = "evening";
                    break;
                case (hour >= 0 && hour < 12):
                    this.timeOfDay = "morning";
                    break;
            }
            this.userFirstName = this.portalUserService.getFirstName();
        }
        this.getPermissions();
        this.getInterviewerDetails();
    }

    /**
     * @note - IAS - not final; we want to get specific roles from the
     * database in addition to large-scale details like 'interviewer' or
     * 'agent'
     */
    getPermissions() {
        console.log('getPermissions called, loggedIn:', this.loggedIn);
        if (this.loggedIn) {
            this.isInterviewerOrAbove = this.portalUserService.isInRoleOrAbove(RoleName.Interviewer);
            console.log('isInterviewerOrAbove:', this.isInterviewerOrAbove);
            if (this.portalUserService.hasInterviewerRole()) {
                this.userRole = 'INT';
                this.isInterviewer = true;
                this.selectedInterviewerId = this.portalUserService.getInterviewerId();
                console.log('Is Interviewer! ID:', this.selectedInterviewerId);
            } else if (this.portalUserService.hasAgentRole()) {
                console.log('User has agent role');
                this.userRole = 'AGT';
                this.isAgent = true;
            } else if (this.portalUserService.hasStaffRole()) {
                console.log('User has staff role (no interviewer role)');
                this.userRole = 'STA';
                this.isStaffOnly = true;
            }
        }
    }

    getInterviewerDetails(): void {
        if (this.selectedInterviewerId) {
            this.interviewerService
                .getInterviewerDetails(this.selectedInterviewerId)
                .subscribe({
                    next: (result: AgencyInterviewerDetailsResponse) => {
                        this.interviewer = result?.details;
                        this.isOnlineInterviewer = result?.details!.isOnlineInterviewer;
                        this.getOverdueReports();
                    },
                    error: (error) => {
                        console.error(error);
                    }
                });
        }
    }

    getOverdueReports(): void {
        this.interviewerService
            .getOverdueReportCount(this.selectedInterviewerId)
            .subscribe({
                next: (count: number) => {
                    this.overdueLimitReached = (count > this.interviewer!.overdueReportLimit);
                }
            })
    }

    interviewer?: AgentInterviewerDetails;
    overdueLimitReached = false;

    isInterviewerOrAbove: boolean = false;
    selectedInterviewerId: number = 0;
    isOnlineInterviewer: boolean = true;
}
